// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__qGK1P","loadingSpinnerContainer":"Toggle_loadingSpinnerContainer__lLjiY","toggle-slider":"Toggle_toggle-slider__B7eZr"};